import { NavDropdown } from "react-bootstrap";
import styles from "./NavDropdownNested.module.scss";
import { Link } from "react-router-dom";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";

import "react-bootstrap-submenu/dist/index.css";
import useLang from "hooks/useLang";

const NavDropdownNested = ({ title, items }) => {
  const { lang } = useLang();

  return (
    <li className={["nav-item dropdown", styles.navDropdownNested].join(" ")}>
      <NavDropdownMenu title={title}>
          <NavDropdown.Item as={Link} to="/services">
            {lang.navigation.services_dropdown_1}
            </NavDropdown.Item>
        <DropdownSubmenu href="#action/3.7" title={lang.navigation.services_dropdown_2}>
          {items.map((item) => (
            <NavDropdown.Item as={Link} to={item.to}>{item.title}</NavDropdown.Item>
          ))}
        </DropdownSubmenu>
      </NavDropdownMenu>
    </li>
  );
};

export default NavDropdownNested;
